import styled from "styled-components";

const FoodTypeCard = styled.div`
  width: 100%;
  height: 124px;
  background-color: #f9fafb;
  border: 1px solid #e8f0f9;
  border-radius: 10px;
  padding: 12px;
  gap: 6px;
  box-shadow: 0 0 0 1px rgba(232, 240, 249, 0.25);
  text-align: center;
`;

const IconCircle = styled.div`
  background-color: #2563eb;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  max-width: 48px;
  max-height: 48px;
  min-width: 48px;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CardLabel = styled.div`
  margin-top: 8px;
  line-height: 16px;
  color: #374151;
`;

export default function FoodCategoryCard({ label, icon }) {
  return (
    <FoodTypeCard className="d-flex flex-column align-items-center justify-content-center">
      <IconCircle className="d-flex align-items-center justify-content-center">
        {icon}
      </IconCircle>
      <CardLabel className="text-center fw-medium size-14">{label}</CardLabel>
    </FoodTypeCard>
  );
}
